export function ChatPing() {
  return (
    <span className="absolute bottom-1 left-1/2 right-1/2 flex h-2 w-2 -translate-x-1/2 items-center justify-center">
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-400 opacity-75"></span>
      <span className="relative inline-flex h-1 w-1 rounded-full bg-red-500"></span>
    </span>
  );
}
